// 订单处理 namespace key
export const ORDER_AUDIT = 'orderAudit';
// 获取订单处理
export const GET_TRADE_SEARCH = 'getTradeSearch';
// 获取此次查询条件的总数量
export const GET_TRADE_SEARCH_COUNT = 'getTradeSearchCount';
// 设置搜索数据
export const SET_SEARCH_MODEL = 'setSearchModel';
// 设置分页数据
export const SET_PAGINATION_MODEL = 'setPaginationModel';
// 获取快捷查询
export const GET_TRADE_SEARCH_CUSTOM_LIST = 'getTradeSearchCustomList';
// 设置快捷查询
export const SET_TRADE_SEARCH_CUSTOM_LIST = 'setTradeSearchCustomList';
// 设置表格数据
export const SET_AUDIT_TABLE_DATA = 'setAuditTableData';
// 保存当前的 tab
export const SET_CURRENT_TAB = 'set_current_tab';
// 获取标签
export const GET_TRADE_TAG_LIST = 'getTradeTagList';
// 设置标签
export const SET_TRADE_TAG_LIST = 'setTradeTagList';
// 设置字典数据
export const GET_DICTIONARY_DATA = 'get_dictionary_data';
export const SET_DICTIONARY_DATA = 'set_dictionary_data';

// 设置自定义异常
export const GET_CUSTOM_EXCEPTION = 'get_custom_exception';
// 设置交易配置
export const GET_TRADE_SETTINGS = 'getTradeSetting';
export const SET_TRADE_SETTINGS = 'setTradeSetting';
export const GET_TRADE_SETTINGS_NEW = 'getTradeSettingNew';
export const SET_TRADE_SETTINGS_NEW = 'setTradeSettingNew';

// 交易列表商品信息展示
export const GET_LIST_GOODSINFO_SETTINGS = 'getListGoodsSettings';
export const SET_LIST_GOODSINFO_SETTINGS = 'setListGoodsSettings';

// 设置pageSize
export const GET_TRADE_PAGESIZE = 'getTradePageSize';
export const SET_TRADE_PAGESIZE = 'setTradePageSize';

// 审核状态数量统计
export const SET_AUDIT_STATUS_COUNT = 'setAuditStatusCount';
export const GET_AUDIT_STATUS_COUNT = 'getAuditStatusCount';

// 列表加载保留上次渲染索引表示
export const SET_LIST_KEEP_LAST_RENDER_INDEX = 'setListKeepLastRenderIndex';
